import * as React from "react"
import "./userTimestamp.css"

/**
 * Timezone label shown after a date, slightly smaller than the date: " (America/Cancun)".
 */
export function AppTimezoneLabel({ tz }) {
    if (!tz) return null
    return <span className="app-tz-label">({tz})</span>
}

/**
 * Backend timestamp in the user's timezone: `local` (`<field>_local`) + its `tz` label.
 * Falls back to the raw UTC value labelled UTC when the local copy is missing, or to `empty`.
 * `format` (optional) reformats the "YYYY-MM-DD HH:MM:SS" string before rendering.
 */
export default function AppUserTimestamp({ local, tz, utc, length = 19, empty = '', format }) {
    const value = local || utc
    if (!value) return empty
    const text = String(value).replace('T', ' ').substring(0, length)
    return <>
        {format ? format(text) : text}
        <AppTimezoneLabel tz={local ? tz : 'UTC'} />
    </>
}
